import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
export function TireRotationPage() {
  return <div data-id="element-1204">
      {/* Page Header */}
      <div className="bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1205">
        <p className="text-[#822433] font-bold text-sm uppercase tracking-widest mb-3" data-id="element-1206">
          Our Services
        </p>
        <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-1207">
          🔄 Tire Rotation & Alignment
        </h1>
        <p className="text-gray-400 text-base mt-4 max-w-xl mx-auto" data-id="element-1208">
          Extend tire life, improve fuel efficiency, and keep your vehicle
          driving straight.
        </p>
      </div>

      {/* Main Content */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-1209">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-1210">
          <div data-id="element-1211">
            <h2 className="text-2xl sm:text-3xl font-black text-black mb-5" data-id="element-1212">
              Keep Your Tires Wearing Evenly
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5" data-id="element-1213">
              Tires wear differently depending on their position on your
              vehicle. Front tires carry more weight and handle steering,
              causing them to wear faster. Regular rotation moves tires between
              positions so they wear evenly — extending their life by thousands
              of miles.
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-1214">
              Wheel alignment ensures your tires make proper contact with the
              road. Misalignment causes rapid, uneven wear and can make your
              vehicle pull to one side. We recommend alignment checks every
              6,000–8,000 miles or whenever you notice handling issues.
            </p>
          </div>

          {/* What's Included */}
          <div className="bg-[#F5F5F5] rounded-lg p-8" data-id="element-1215">
            <h3 className="font-black text-black text-xl mb-6" data-id="element-1216">
              What's Included
            </h3>
            <ul className="space-y-4" data-id="element-1217">
              <li className="flex items-start gap-3" data-id="element-1218">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1219" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1220">
                  Full 4-tire rotation following manufacturer pattern
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1221">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1222" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1223">
                  Tire pressure check and adjustment on all 4 tires
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1224">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1225" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1226">
                  Tread depth measurement and wear pattern analysis
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1227">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1228" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1229">
                  Computerized wheel alignment measurement
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1230">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1231" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1232">
                  Camber, caster, and toe adjustment as needed
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1233">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1234" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1235">
                  FREE rotation for life with every tire purchase
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why It Matters */}
      <section className="w-full bg-[#F5F5F5] py-16 px-4 sm:px-6 lg:px-8" data-id="element-1236">
        <div className="max-w-5xl mx-auto" data-id="element-1237">
          <h2 className="text-2xl sm:text-3xl font-black text-black mb-6 text-center" data-id="element-1238">
            Signs You Need Rotation or Alignment
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1239">
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1240">
              <div className="text-3xl mb-3" style={{
              background: '#CC0000'
            }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-1241">
                ↔️
              </div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1242">
                Vehicle Pulling
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1243">
                If your car drifts left or right on a straight road, your
                alignment is likely off.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1244">
              <div className="text-3xl mb-3" data-id="element-1245">📐</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1246">
                Uneven Wear
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1247">
                One tire wearing faster than others is a clear sign rotation is
                overdue.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1248">
              <div className="text-3xl mb-3" data-id="element-1249">📅</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1250">
                Every 6,000 Miles
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1251">
                Even without symptoms, rotate every 6,000–8,000 miles to
                maximize tire lifespan.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="w-full bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1252">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3" data-id="element-1253">
          Ready to Get Started?
        </h2>
        <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto" data-id="element-1254">
          Schedule your rotation and alignment today — quick service, no
          appointment needed.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1255">
          <Link to="/contact" className="inline-flex items-center justify-center bg-[#822433] hover:bg-[#6B1D29] text-white font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1256">
            Book an Appointment
          </Link>
          <Link to="/services" className="inline-flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-black font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1257">
            View All Services
          </Link>
        </div>
      </section>
    </div>;
}